import React, { useCallback, useRef, useState } from 'react';
// designComponents
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import FlexMainWrapper, { Wrapper02 } from '../../designComponents/wrappers/FlexMainWrapper';
import MainTable from '../../designComponents/tables/MainTable';
import { gatheringAllChatFilter } from '../../components/ChattingComponents/ChattingTableFilter';
import { ChatModalComponent } from '../../designComponents/modals/ModalComponent';
import ServerChatDetail from '../../components/ChattingComponents/ServerChatDetail';
import { MText } from '../../designComponents/text/ContentText';
import SearchbarWithDropdown from '../../designComponents/searchbars/SearchbarWithDropdown';
import ToggleSwitch from '../../common/BootStrap/ToggleSwitch';
import { getChattingListRequest, patchChattingDisabledRequest } from '../../api/main/chatting/ChattingRequest';

/**  페이지 */
const GatheringAllChat = () => {
    const [param, setParam] = useState({ order: -1 });
    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState('');

    const [chatParams, setChatParams] = useState({ toggle: false });

    const ref = useRef(null);
    const tableRef = useRef(null);

    const callApi02 = async (page, param) => {
        try {
            /** 1: 친구, 2: 모임, 3: 모임단체 */
            const input = {
                page: page,
                size: 10,
                ...param,
            };
            if (searchType === 1) {
                input.name = searchText;
            } else if (searchType === 2) {
                input.phone = searchText;
            } else if (searchType === 3) {
                input.nickName = searchText;
            }
            const response = await getChattingListRequest(input, 3);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const onChangeDisabledChatting = async (e) => {
        const checkedYn = e.target.checked;
        const chattingId = e.target.id;

        if (!chattingId) {
            return alert('채팅창 ID가 없습니다,  관리자에게 문의해주세요 ');
        }
        try {
            await patchChattingDisabledRequest({
                room_id: chattingId,
                disable: !checkedYn,
            });
            if (checkedYn) {
                e.target.label = '활성화';
            } else {
                e.target.label = '비활성화';
            }
        } catch (err) {
            if (err.response.status_code === 500) {
                alert('네트 워크 오류, 관리자에게 문의해주세요');
            }
        }
    };

    return (
        <Wrapper02>
            <MainPageTitle text={'모임 단체 대화방'} onClick={() => ref?.current?.refresh()} />
            <SearchbarWithDropdown
                list={[
                    { id: 1, title: '모임명', value: 1 },
                    { id: 2, title: '모임장 전화번호', value: 2 },
                    { id: 3, title: '모임장 닉네임', value: 3 },
                ]}
                resetThenSet={useCallback((item) => {
                    setSearchType(item.value);
                }, [])}
                onChangeSubmit={(e) => {
                    e.preventDefault();
                    ref?.current?.refresh();
                }}
                searchText={searchText}
                onChangeInput={(e) => {
                    setSearchText(e.target.value);
                }}
                setSearchText={setSearchText}
            />

            <FlexMainWrapper>
                <MainTable
                    scrollWidth={chatParams.toggle ? 110 : 155}
                    buttonComponents={({ checkItems }) => {}}
                    ref={ref}
                    tableStyle={{ width: chatParams.toggle ? '70%' : '98%' }}
                    tableRef={tableRef}
                    loadingText={'채팅 내역을 불러오고 있습니다.'}
                    headerData={gatheringAllChatFilter}
                    checkID={'id'}
                    param={param}
                    setParam={setParam}
                    callApi={callApi02}
                    toggleBlur={true}
                    onClickRowItem={(item) => async () => {
                        if (!item.room_id) return alert('대화방 ID가 없습니다.');
                        setChatParams({ toggle: true, chatId: item.room_id, item });
                    }}
                    tbodyRenderItem={(key, value, data) => {
                        const nullTag = <span style={{ color: '#797979' }}>정보없음</span>;

                        if (key === 'disable')
                            return (
                                <div style={{ display: 'flex', justifyContent: 'center' }} onClick={(e) => e.stopPropagation()}>
                                    <ToggleSwitch initChecked={!data.disable} onChange={onChangeDisabledChatting} id={data.room_id} label={!data.disable ? '활성화' : '비활성화'} />
                                </div>
                            );
                        if (key === 'to') {
                            return (
                                <span>
                                    <span>{data?.manager_name}</span>
                                    <span>/</span>
                                    <span>{data?.manager_nick_name}</span>
                                </span>
                            );
                        }
                        if (key === 'crewCount') return `${data.users.length || 0}명`;
                        return value;
                    }}
                />
                {chatParams.toggle && (
                    <ChatModalComponent
                        toggle={chatParams.toggle}
                        closeModal={() => setChatParams({ toggle: false })}
                        header={<MText text={chatParams.item?.gathering_name || '모임 단체 대화방'} color="#000" />}
                        body={<ServerChatDetail chatId={chatParams.chatId} />}
                        inputOn={false}
                        boxStyle={{ paddingBottom: '10px' }}
                        bodyStyle={{ paddingBottom: '20px' }}
                    />
                )}
            </FlexMainWrapper>
        </Wrapper02>
    );
};

export default GatheringAllChat;
